import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { Redirect } from 'react-router-dom';
import { Layout, Result, Typography } from 'antd';
import firebase from '../../firebase';
import Sidebar from './Sidebar';
import ManageHoliday from '../../containers/dashboard/ManageHoliday';
import SearchBookings from '../../containers/dashboard/SearchBookings';
import Overview from '../../containers/dashboard/Overview';
import Services from '../../containers/dashboard/Services';


const { Content } = Layout;
const { Paragraph } = Typography;

const style = {
    layout: {
        minHeight: '100vh',
    },
    content: {
        margin: '16px 16px 0',
    },
    titleWrapper: {
        margin: '24px 0',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
    },
};

class Dashboard extends Component {
    state = {
        activeMenuItem: 'overview',
        handleLogout: false,
        isLogoutLoading: false,
    };

    handleLogout = async () => {
        this.setState({ isLogoutLoading: true });

        await firebase.auth().signOut();
        
        this.setState({ isLogoutSuccess: true });
    }

    handleMenuItemChange = e => {
        this.setState({ activeMenuItem: e.key });
    }

    renderContent = () => {
        const { activeMenuItem } = this.state;

        switch (activeMenuItem) {
            case 'holiday':
                return <ManageHoliday />;
            case 'search':
                return <SearchBookings />;
            case 'services':
                return <Services />;
            case 'overview':
            default:
                return <Overview />;
        }
    }

    render() {
        const { 
            isLogoutLoading,
            isLogoutSuccess,
        } = this.state;

        if (isMobile) {
            return (
                <div style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
                    <Result
                        status="warning"
                        title="Oh no! You're using a mobile device"
                        extra={
                            <Paragraph>
                                Please login on your PC to use the dashboard.
                            </Paragraph>
                        }
                    />
                </div>
            );
        }

        if (isLogoutSuccess) {
            return <Redirect to="/" />;
        }

        return (
            <Layout style={style.layout}>
                <Sidebar 
                    onMenuItemChange={this.handleMenuItemChange}
                    handleLogout={this.handleLogout}
                    isLogoutLoading={isLogoutLoading}
                />
                <Layout>
                    <Content style={style.content}>
                        { this.renderContent() }
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default Dashboard;
